export const MESSAGE_SEND_REQUEST = 'MESSAGE_SEND_REQUEST';
export const MESSAGE_LIST_REQUEST = 'MESSAGE_LIST_REQUEST';
export const MESSAGE_THREAD_REQUEST = 'MESSAGE_THREAD_REQUEST';
export const RELOAD_THREAD_REQUEST = 'RELOAD_THREAD_REQUEST';
